<template>
  <div
    :class="[
      $style.container,
      computedClasses,
    ]"
    @click.self="handleFocus"
  >
    <masked-input
      :ref="internalRef"
      :value="value"
      :mask="mask"
      :pipe="autocorrectPipe"
      :placeholder="placeholder"
      :disabled="disabled"
      @input="handleInput"
      @focus="handleFocus"
      @blur="handleBlur"
      @submit="handleSubmit"
      @change="handleChange"
    />
    <span
      v-if="$scopedSlots.hasOwnProperty('action')"
      v-d-flex
    >
      <slot
        :focus="internalFocus"
        name="action"
      />
    </span>
  </div>
</template>

<script>
import MaskedInput from 'vue-text-mask';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';

import moment from 'lib/utils/date';

import inputMixin from 'lib/mixins/inputMixin';

const autoCorrectedDatePipe = createAutoCorrectedDatePipe('dd.mm.yyyy', {
  minYear: 2017,
  maxYear: Number(moment().format('YYYY')),
});

export default {
  name: 'MaskedDateInput',
  mixins: [
    inputMixin,
  ],
  components: {
    MaskedInput,
  },
  data() {
    return {
      autocorrectPipe: autoCorrectedDatePipe,
      mask: [/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/],
    };
  },
};
</script>

<style lang="sass" module>
  @import '~styles/components/base/input'

  .container
    padding: 5px 10px
</style>
